export const ADMIN_PERMISSIONS = Object.freeze({
  DASHBOARD: "dashboard",
  CANCELLATIONS_RETURNS: "cancellationsReturns",
  ORDERS: "orders",
  FULL_METRICS: "fullMetrics",
  PRODUCTS: "products",
  REPORTS: "reports",
  USERS: "users",
  STARBOX: "starbox",
  AISTEM: "aistem",
  CONFIG: "config",
  GESTOR: "gestor",
  DEVELOPER: "developer",
  STALLED_ORDERS: "stalledOrders",
  NFES: "nfe",
  TRELLO: "trello",
  AUTO_PACK_ORDERS: "autoPackOrders",
  AUTO_PRINT_PRODUCT_LABELS: "autoPrintProductLabels",
} as const);

export type AdminPermission =
  (typeof ADMIN_PERMISSIONS)[keyof typeof ADMIN_PERMISSIONS];

export const PRINT_ROUTES = Object.freeze({
  SHIPPING_DOCUMENTS: "shippingDocuments",
  PRODUCT_LABELS: "productLabels",
  FRAGILE_LABELS: "fragileLabels",
} as const);

export type PrintRoute = (typeof PRINT_ROUTES)[keyof typeof PRINT_ROUTES];

export const LEGACY_PRINT_ROUTE_SLOTS: Readonly<Record<PrintRoute, string>> = Object.freeze({
  [PRINT_ROUTES.PRODUCT_LABELS]: "1",
  [PRINT_ROUTES.SHIPPING_DOCUMENTS]: "2",
  [PRINT_ROUTES.FRAGILE_LABELS]: "3",
});

export interface AdminUser {
  id?: number | string;
  name?: string;
  email?: string;
  photo?: string;
  printingConfig?: Record<string, string>;
  userConfig?: {
    printFragile?: boolean;
    [key: string]: unknown;
  };
  config?: {
    permissions?: AdminPermission[];
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

export const hasAnyPermission = (
  user: AdminUser | null | undefined,
  required: AdminPermission | readonly AdminPermission[] = [],
) => {
  const permissions = user?.config?.permissions || [];
  const normalized = Array.isArray(required) ? required : [required];
  return normalized.length === 0 || normalized.some((entry) => permissions.includes(entry));
};

export const resolveOrizomAssetUrl = (
  assetPath: string | null | undefined,
  directory: string,
  baseUrl = "https://orizom.com.br",
) => {
  const normalized = String(assetPath || "").trim();
  if (!normalized) return "";

  const normalizedBase = baseUrl.replace(/\/+$/, "");
  if (/^https?:\/\//i.test(normalized)) {
    try {
      const url = new URL(normalized);
      return `${normalizedBase}${url.pathname}${url.search}${url.hash}`;
    } catch {
      return normalized;
    }
  }

  const relativePath = normalized.replace(/^\/+/, "");
  if (relativePath.startsWith("uploads/")) {
    return `${normalizedBase}/${relativePath}`;
  }

  return `${normalizedBase}/uploads/${directory}/${relativePath}`;
};
export { getPrintingBrowserId, printingStationFetch, PRINTING_BROWSER_KEY, PRINT_CONFIG_REQUIRED_EVENT, PRINT_STATION_CHANGED_EVENT, PRINT_CONFIG_MESSAGE } from "./printingStation";
